import {
  Block,
  Box,
  MainContainer,
  Image
} from "../../../styles/basicStyles";
import { useTranslation } from "next-i18next";
import { colors } from "../../../styles/colors";
import { FC } from "react";
import Typography from "../../../components/typography";
import Icon from "../../../components/icon";
import Dot from "../../../components/views/dot";

interface TestimoniesProps {
  image: string;
  author: string;
  role: string;
  testimony: string;
  companyLogo: string;
}

const Testimonies: FC<TestimoniesProps> = ({
  image,
  author,
  role,
  testimony,
  companyLogo
}) => {
  const { t } = useTranslation();

  return (
    <Block
      w="100%"
      bgColor={colors.chineseBlack}
      pt={{ md: 5.375, xxs: 3.438 }}
      pb={{ md: 8.75, xxs: 4.125 }}
      mb={{ md: "7.5rem", xxs: "3.125rem" }}
      position="relative"
    >
      <Box fJustify="center" fAlign="center" fDirection="column">
        <MainContainer>
          <Box fDirection="column" position="relative">
            <Typography
              fSize={{ md: 2.813, xxs: 1.688 }}
              lHeight={{ md: 3.375, xxs: 2 }}
              fWeight={700}
              style={{ color: colors.white }}
            >
              {t("TESTIMONY")}
              <Dot
                w={{ md: 0.875, xxs: 0.5 }}
                h={{ md: 0.875, xxs: 0.5 }}
                ml={0.375}
              />
            </Typography>
            <Block
              position="absolute"
              top={{ md: 8, xxs: 15 }}
              right={{ md: 0, xxs: "unset" }}
              left={{ md: "unset", xxs: -4 }}
            >
              <Icon
                icon="outlined_quotationMark"
                size={[10.438, 14]}
                color={colors.white}
              />
            </Block>
            <Block
              display="flex"
              mt={{ md: 4.25, xxs: 3.438 }}
              fJustify="center"
              minW="100%"
              fDirection={{ md: "row", xxs: "column" }}
            >
              <Box
                w="unset"
                fAlign={{ md: "flex-start", xxs: "center" }}
                mb={{ md: 0, xxs: 3.875 }}
              >
                <Image
                  loading='lazy'
                  src={image}
                  h={{ md: 12.5, xxs: 5 }}
                  w={{ md: 12.5, xxs: 5 }}
                  bRadius={0.25}
                  mr={{ md: 3.625, xxs: 1.25 }}
                  alt='image'
                />
                <Box
                  display={{ md: "none", xxs: "flex" }}
                  fAlign="flex-start"
                  fWrap="wrap"
                  fDirection="column"
                >
                  <Typography
                    fSize={{ sm: 1.563, xxs: 1.25 }}
                    lHeight={{ sm: 2, xxs: 1.75 }}
                    fWeight={600}
                    color={colors.white}
                  >
                    {author}
                  </Typography>
                  <Box fAlign='center'>
                    <Typography
                      fSize={1.25}
                      lHeight={2}
                      fWeight={400}
                      color={colors.white}
                      opacity={0.5}
                      mr={{ md: 0.688, xxs: 1.125 }}
                    >
                      {role}
                    </Typography>
                    <Image 
                      loading='lazy'
                      src={companyLogo} 
                      w='auto'
                      h='auto'
                      maxH={1.875}
                      alt='logo'
                    />
                  </Box>
                </Box>
              </Box>
              <Box fDirection="column" maxW={{ md: 42.125, xxs: "100%" }}>
                <Typography
                  fSize={{ sm: 1.438, xxs: 1.25 }}
                  lHeight={{ sm: 2.25, xxs: 2 }}
                  fWeight={350}
                  color={colors.white}
                >
                  {testimony}
                </Typography>
                <Box
                  display={{ md: "flex", xxs: "none" }}
                  fAlign="flex-start"
                  mt={2.188}
                  fDirection="column"
                >
                  <Typography
                    fSize={1.563}
                    lHeight={2}
                    fWeight={600}
                    color={colors.white}
                  >
                    {author}
                  </Typography>
                  <Box fAlign="center" mt={0.75}>
                    <Typography
                      fSize={1.25}
                      lHeight={2}
                      fWeight={400}
                      color={colors.white}
                      opacity={0.5}
                    >
                      {role}
                    </Typography>
                    <Image
                      loading='lazy'
                      src={companyLogo}
                      ml={{ md: 0.688, xxs: 1.125 }}
                      w='auto'
                      h='auto'
                      maxH={1.875}
                      alt='logo'
                    />
                  </Box>
                </Box>
              </Box>
            </Block>
          </Box>
        </MainContainer>
      </Box>
    </Block>
  );
};

export default Testimonies;
